import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedGenderView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'enhanced_gender'
  alias: "Gender"
  humanize: true

  removeFilter: (value) ->
    @searchQuery.removeGender(value)
